export default __webpack_public_path__ + "static/media/fast-cashout.a85c6bd0.svg";